// @ts-strict-ignore
import { useState } from 'react'
import { useDebounce } from '@node-space/hooks'
import { SEARCH_INPUT_DEBOUNCE_TIME } from 'constants/General'
import { useCustomersQuery } from 'hooks/queries/Customers/useCustomersQuery'
import { useGetPayoutsTransferWalletsQuery } from 'hooks/queries/useGetPayoutsTransferWalletsQuery'
import { MovePayload } from 'pages/NestedCustomers/types'
import { Customer } from 'types/customers'
import { SourceWallet } from 'types/move/move'

interface UseMoveFormDataProps {
  sourceWallet: SourceWallet | null
  formValues: MovePayload
}

export const useMoveFormQueryData = ({ sourceWallet, formValues }: UseMoveFormDataProps) => {
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedSearchTerm = useDebounce(searchQuery, SEARCH_INPUT_DEBOUNCE_TIME)

  const [walletNameSearch, setWalletNameSearch] = useState('')
  const debouncedWalletNameSearch: string = useDebounce(walletNameSearch, SEARCH_INPUT_DEBOUNCE_TIME)

  const {
    data: { content: customerList } = {},
    isFetching: isFetchingCustomers,
    error: fetchingCustomersError,
  } = useCustomersQuery<Customer>({
    size: 1000,
    search: debouncedSearchTerm,
  })

  const {
     data: { content: transferWallets } = {},
    isFetching: isFetchingTransferWallets,
    error: transferWalletsErrors,
    refetch: fetchTransferWallets,
  } = useGetPayoutsTransferWalletsQuery(
    {
      walletId: sourceWallet?.walletId,
      currencyCode: sourceWallet?.currency,
      walletType: formValues?.walletTransferType,
      customerReference: formValues?.customerReference,
      walletName: debouncedWalletNameSearch,
      pageNumber: 0,
      pageSize: 50,
    },
    false
  )

  return {
    customerList: customerList || [],
    transferWallets: transferWallets || [],
    isFetchingCustomers,
    isFetchingTransferWallets,
    isLoading: isFetchingCustomers || isFetchingTransferWallets,
    queryFetchingErrors: {
      customers: fetchingCustomersError,
      transferWallets: transferWalletsErrors,
    },
    fetchTransferWallets,
    searchQuery,
    setSearchQuery,
    setWalletNameSearch,
    debouncedWalletNameSearch,
  }
}
